(function () {
  if (window.__mtInit) return;
  window.__mtInit = true;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var observer = null;

  function initReveals(root) {
    var els = (root || document).querySelectorAll('.mt-reveal:not(.mt-visible), .mt-pasos:not(.mt-visible)');
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('mt-visible'); });
      return;
    }
    if (!observer) {
      observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('mt-visible'); observer.unobserve(e.target); }
        });
      }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
    }
    els.forEach(function (el) { observer.observe(el); });
  }

  /* Héroe spotlight: el foco sigue al cursor */
  function initSpotlight(root) {
    (root || document).querySelectorAll('[data-mt-spotlight]').forEach(function (el) {
      if (el.dataset.mtInit) return;
      el.dataset.mtInit = '1';
      if (reduce || window.matchMedia('(hover: none)').matches) return;
      var raf = null;
      el.addEventListener('mousemove', function (ev) {
        var r = el.getBoundingClientRect();
        var x = ((ev.clientX - r.left) / r.width) * 100;
        var y = ((ev.clientY - r.top) / r.height) * 100;
        if (raf) cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () {
          el.style.setProperty('--mx', x + '%');
          el.style.setProperty('--my', y + '%');
        });
      });
    });
  }

  /* CTA magnético */
  function initMagnetico(root) {
    (root || document).querySelectorAll('[data-mt-magnetico]').forEach(function (btn) {
      if (btn.dataset.mtInit) return;
      btn.dataset.mtInit = '1';
      if (reduce || window.matchMedia('(hover: none)').matches) return;
      btn.addEventListener('mousemove', function (ev) {
        var r = btn.getBoundingClientRect();
        var dx = (ev.clientX - (r.left + r.width / 2)) / r.width;
        var dy = (ev.clientY - (r.top + r.height / 2)) / r.height;
        btn.style.transform = 'translate(' + (dx * 8).toFixed(1) + 'px,' + (dy * 6).toFixed(1) + 'px)';
      });
      btn.addEventListener('mouseleave', function () { btn.style.transform = ''; });
    });
  }

  /* Hotspots */
  function initHotspots(root) {
    (root || document).querySelectorAll('[data-mt-hotspots]').forEach(function (wrap) {
      if (wrap.dataset.mtInit) return;
      wrap.dataset.mtInit = '1';
      var puntos = wrap.querySelectorAll('[data-mt-punto]');
      var items = wrap.querySelectorAll('[data-mt-item]');
      function activar(i) {
        puntos.forEach(function (p) { p.classList.toggle('mt-activo', p.dataset.mtPunto === i); });
        items.forEach(function (p) { p.classList.toggle('mt-activo', p.dataset.mtItem === i); });
      }
      puntos.forEach(function (p) {
        p.addEventListener('mouseenter', function () { activar(p.dataset.mtPunto); });
        p.addEventListener('click', function () {
          activar(p.dataset.mtPunto);
          var it = wrap.querySelector('[data-mt-item="' + p.dataset.mtPunto + '"]');
          if (it && window.innerWidth < 990) it.scrollIntoView({ behavior: 'smooth', block: 'center' });
        });
      });
      items.forEach(function (it) {
        it.addEventListener('mouseenter', function () { activar(it.dataset.mtItem); });
        it.addEventListener('click', function () { activar(it.dataset.mtItem); });
      });
      if (puntos.length) activar(puntos[0].dataset.mtPunto);
    });
  }

  /* FAQ */
  function initFaq(root) {
    (root || document).querySelectorAll('[data-mt-faq]').forEach(function (faq) {
      if (faq.dataset.mtInit) return;
      faq.dataset.mtInit = '1';
      faq.querySelectorAll('.mt-faq__q').forEach(function (q) {
        q.addEventListener('click', function () {
          var item = q.closest('.mt-faq__item');
          var abierto = item.classList.toggle('mt-abierto');
          q.setAttribute('aria-expanded', abierto ? 'true' : 'false');
        });
      });
    });
  }

  /* Página de producto: galería + variantes */
  function initProducto(root) {
    (root || document).querySelectorAll('[data-mt-producto]').forEach(function (pp) {
      if (pp.dataset.mtInit) return;
      pp.dataset.mtInit = '1';
      var principal = pp.querySelector('[data-mt-principal]');
      pp.querySelectorAll('[data-mt-mini]').forEach(function (mini) {
        mini.addEventListener('click', function () {
          pp.querySelectorAll('[data-mt-mini]').forEach(function (m) { m.classList.remove('mt-activo'); });
          mini.classList.add('mt-activo');
          if (principal) { principal.src = mini.dataset.mtMini; principal.removeAttribute('srcset'); }
        });
      });

      var datos = pp.querySelector('[data-mt-variantes]');
      if (!datos) return;
      var variantes = JSON.parse(datos.textContent);
      var form = pp.querySelector('[data-mt-form]');
      var inputId = form ? form.querySelector('input[name="id"]') : null;
      var precio = pp.querySelector('[data-mt-precio]');
      var tachado = pp.querySelector('[data-mt-tachado]');
      var boton = pp.querySelector('[data-mt-boton]');
      var formato = pp.dataset.mtMoneda || '{{amount}}';
      function dinero(cents) {
        var v = (cents / 100).toFixed(2);
        var coma = v.replace('.', ',');
        return formato.replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, coma).replace(/\{\{\s*amount\s*\}\}/, v).replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100));
      }
      function actualizar() {
        var sel = [];
        pp.querySelectorAll('[data-mt-opcion]').forEach(function (fs) {
          var c = fs.querySelector('input:checked');
          sel.push(c ? c.value : null);
        });
        var v = variantes.find(function (va) {
          return va.options.every(function (o, i) { return o === sel[i]; });
        });
        if (!v) return;
        if (inputId) inputId.value = v.id;
        if (precio) precio.textContent = dinero(v.price);
        if (tachado) {
          if (v.compare_at_price && v.compare_at_price > v.price) { tachado.textContent = dinero(v.compare_at_price); tachado.hidden = false; }
          else { tachado.hidden = true; }
        }
        if (boton) {
          boton.disabled = !v.available;
          boton.querySelector('span').textContent = v.available ? boton.dataset.mtTexto : boton.dataset.mtAgotado;
        }
        if (v.featured_image && principal) { principal.src = v.featured_image.src; principal.removeAttribute('srcset'); }
      }
      pp.querySelectorAll('[data-mt-opcion] input').forEach(function (inp) { inp.addEventListener('change', actualizar); });
    });
  }

  function initTodo(e) {
    var root = e && e.target && e.target.querySelectorAll ? e.target : document;
    initReveals(root);
    initSpotlight(root);
    initMagnetico(root);
    initHotspots(root);
    initFaq(root);
    initProducto(root);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initTodo);
  else initTodo();
  document.addEventListener('shopify:section:load', initTodo);
})();
